import './style.scss';

console.log(`Theme front loaded!`)
